import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {checkDomianFn} from '@didi/domain-for-ru';
import {getEnd, getDomainSuffix, getCookie} from './utils';
import {SUPPORT_COUNTRY_CONFIG} from './constant';
import store from '../store';

Vue.use (VueAxios, axios);

axios.defaults.headers.common['Content-Type'] =
  'application/x-www-form-urlencoded';
axios.defaults.timeout = 60 * 1000;
axios.interceptors.request.use (
  function (config) {
    // Do something before request is sent
    //post 时添加end 通用参数,data一定是URLSearch
    if (config.method === 'post') {
      config.data.set ('end', getEnd ());
      try {
        let _oid = config.data.get('oid')
        if (!_oid) {
          config.data.set ('oid', Omega.getOmgid ());
        }
      } catch (e) {}
      let c = config.data.get ('location_country');
      //@20190422 语言由前端配置
      // 20210113 去除此逻辑，走开国配置化逻辑
      // config.data.set ('lang', SUPPORT_COUNTRY_CONFIG[c]['lang']);
      // if (c !== 'BR') {
      //无产品线时，默认取store内的值
      if (!config.data.has ('product')) {
        config.data.set ('product', store.state._product);
      }
      // 无角色时，默认取store内的值
      if (!config.data.has ('identity')) {
        config.data.set ('identity', store.state._identity);
      }
      //@20200623 支持车头、司机角色转换,新增结果页转换入口；优先信任store
      let r = store.state._roleTrans;
      if (r) {
        config.data.set ('roleTrans', r);
      }
      // }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject (error);
  }
);

function post (url, ...configs) {
  //处理域名改造
  const domainSuffix = getCookie("domain_suffix");
  if (domainSuffix !== '-de') {
    if (process.env.DOT_ENV !== 'preview' && process.env.SIM_ENV !== 'sim' && process.env.NODE_ENV !== 'development') {
      if (url === process.env.LOGIN_INFO || /\/driver\/reg\/webSignUp/.test(url)) {
        let urlDomainArr = url.split('.');
        let pageSuffix = getDomainSuffix();
        urlDomainArr[0] += pageSuffix;
        url = urlDomainArr.join('.');
      } else {
        url = checkDomianFn (url);
      }
    }
  }

  return Vue.axios.post (url, ...configs).then (res => res.data).then (res => {
    if (res.errno == 0) {
      return res.data;
    } else {
      return Promise.reject (res);
    }
  }).catch(err => {
    // url最后/后为uploadImg，错误上报参数
    const url_index = url.lastIndexOf("\/");  
    const url_last  = url.substring(url_index + 1, url.length);
    if (url_last === 'uploadImg') {
      configs[0].has('__x_img') && configs[0].delete('__x_img');
      window.Omega && window.Omega.trackEvent("tech_register_page_upload_error", "", {
        params: configs[0].toString(),
      });
    }
    window.Omega && window.Omega.trackError("tech_ibt_growth_ajax_error_bt", "", {
      url: url,
      resp: err,
      desc: '司机注册register接口报错',
      page: 'register'
    });
    window.Omega && window.Omega.trackEvent("tech_ibt_growth_ajax_error_bt", "", {
      url: url,
      resp: err,
      desc: '司机注册register接口报错',
      page: 'register'
    });
    return Promise.reject (err);
  });
}

function get (url, ...configs) {
  //@20200421 特殊处理 RU fleet请求
  try {
    let result = /https:\/\/fleet\.didiglobal\.com(.*)/.exec (url);
    let isMinibus = /minibus/.test(location.pathname)
    if (result) {
      let location_country = configs[0].params.get ('location_country');
      if (location_country === 'RU' || location_country === 'KZ' || location_country === 'UA') {
        url = `https://fms-ru.didiglobal.com${result[1]}`;
      } else if (location_country === 'ZA'){
        url = `https://fms-union.didiglobal.com${result[1]}`;
      } else if (isMinibus) {
        // sim测试
        // url = `https://gsapi-sim122-us01-test.intra.xiaojukeji.com/sim-fms-env${result[1]}`;
        url = `https://fms-union.didiglobal.com${result[1]}`;
      }
    }
  } catch (e) {
    console.log (e);
  }

  return Vue.axios.get (url, ...configs).then (res => res.data).then (res => {
    if (res.errno == 0) {
      return res.data;
    } else {
      return Promise.reject (res);
    }
  }).catch(err => {
    window.Omega && window.Omega.trackError("tech_ibt_growth_ajax_error_bt", err.errno, err.errmsg, {
      url: url,
      resp: err,
      desc: '司机注册register接口报错',
      page: 'register'
    });
    window.Omega && window.Omega.trackEvent("tech_ibt_growth_ajax_error_bt", err.errno, err.errmsg, {
      url: url,
      resp: err,
      desc: '司机注册register接口报错',
      page: 'register'
    });
    return Promise.reject (err);
  });
}
export {post, get};
